////////////////////////////////////////////
//
// Main Nav
//
////////////////////////////////////////////

var isNavOpen = false;

$('.js-main-nav-toggle').click(function(event){
  var $toggle = $(event.currentTarget);
  var $logo = $toggle.parents('.navbar').find('.navbar__logo--main-nav');
  var target = $toggle.data('target');
  var $menu = target ? $(target) : $('#main-nav');

  function openNav() {
    $toggle.addClass('is-open').attr('aria-expanded','true');
    $menu.addClass('is-open').attr('aria-hidden','false');
    $logo.addClass('is-active');
    isNavOpen = true;
  };

  function closeNav() {
    $toggle.removeClass('is-open').attr('aria-expanded','false');
    $menu.removeClass('is-open').attr('aria-hidden','true');
    $logo.removeClass('is-active');
    isNavOpen = false;
  }

  if (isNavOpen) {
    closeNav();
  } else {
    openNav();
  }
});
